import Swal from 'sweetalert2';

export function mostrarMensajeExito({
    title = 'Éxito',
    text = 'Operación completada correctamente...',
    timer = 1500,
    callback = null
}) {
    let progress = false;

    if(timer){
        progress = true;
    }

    return Swal.fire({
        icon: 'success',
        title,
        text,
        timer,
        showConfirmButton: false,
        timerProgressBar: progress,
        didClose: callback
      });
}

export function mostrarMensajeError({
    title = 'Error',
    text = 'Algo no salió como se esperaba...',
    timer = 1500,
    callback = null
}) {

    let progress = false;

    if(timer){
        progress = true;
    }

   return Swal.fire({
    icon: "error",
    title,
    text,
    timer,
    showConfirmButton: true,
    timerProgressBar: progress,
    footer: '<a href="https://wa.pe/CsO90Lq41i" target="_blank" rel="noopener noreferrer" aria-label="Contactar por Whatsapp">Contactar por Whatsapp <i class="fa-brands fa-whatsapp" aria-hidden="true"></i></a>'
  });   
}